<div class="layout">
  <script src="https://sdk.mercadopago.com/js/v2"></script>
  <header class="header">
    <img src="assets/img/logo.png" alt="Prosegur Alarmas" class="logo-large">
  </header>

  <router-outlet style="display: none;"></router-outlet>

  <footer class="footer">
    <p class="text-help">{{ localeService.footer.comunicate || localStorage.getItem("footer_comunicate") }} {{ localeService.footer.telf || localStorage.getItem("footer_telf") }}</p>
    <p class="text-url"><strong>{{ localeService.footer.url || localStorage.getItem("footer_url") }}</strong></p>
  </footer>
</div>